import React, {useState} from 'react';
import StipendLandModel from '../Models/StipendLandModel';
import * as ValgTypes from '../Store/Valg/Types';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';

interface OppsummeringVisningProps {
    basisLan: StipendLandModel,
    reiseStotte: StipendLandModel,
    skolePenger: StipendLandModel,
    rekrutteringsstipend: number,
    valg: ValgTypes.ValgState,
    locale: string,
    valuta: string,

    tittelMinimumTotaltLan: any,
    infoOmLan: any,
    tittelMaksimumTotaltStipend: any,
    infoOmStipend: any,
    lenketekstOmLanOgStipend: any,
    vilkarLukkVilkårGjeldOgBetaling: any,
    vilkarGjeldOgBetalingTittel:any,
    vilkarGjeldOgBetalingTekst: any,
}

export function OppsummeringLanOgStipendComponent (props: OppsummeringVisningProps): JSX.Element {

    const [visVilkarBModal, setVisVilkarModal] = useState(false);

    function formatNumber(tall: number, locale: string = 'nb-NO') : string {
        let tallSomString: string = tall.toString();
        if(locale === 'en-US') {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
        } else {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        }
        return tallSomString;
    }

    function kalkulerTotaltStudieStipend(): string {
        let aar: number = 0;

        let totalStipend: number = props.basisLan.stipendKroner + props.reiseStotte.stipendKroner + props.skolePenger.stipendKroner + props.rekrutteringsstipend;

        //sjekker om det ikke er valgt noen år enda eller om det bare er valgt ett år 
        if(props.valg.gAntallAr === undefined || props.valg.gAntallAr.value === 1) {
            return formatNumber(Math.round(totalStipend), props.locale).toString();
        } else {
            //vi tar minus 1 på år for å få formelen til å gå opp. 
            aar = props.valg.gAntallAr?.value - 1;
        }

        let total: number = totalStipend * Math.pow(1.02, aar) + totalStipend * ((Math.pow(1.02, aar) - 1) / 0.02);

        return formatNumber(Math.round(total), props.locale).toString();
    }

    function kalkulerTotaltStudieLan() : string {
        let aar: number = 0;
        
        let totalLanForsteAar: number = props.basisLan.lanKroner + props.reiseStotte.lanKroner + props.skolePenger.lanKroner;

        if(props.valg.gAntallAr === undefined || props.valg.gAntallAr.value === 1) {
            return formatNumber(Math.round(totalLanForsteAar), props.locale).toString();
        } else {
            //vi tar minus 1 på år for å få formelen til å gå opp. 
            aar = props.valg.gAntallAr?.value - 1;
        }
        
        let total: number = totalLanForsteAar * Math.pow(1.02, aar) + totalLanForsteAar * ((Math.pow(1.02, aar) - 1) / 0.02);

        return formatNumber(Math.round(total), props.locale).toString();
    }

    function onVilkarClick(): void {
        setVisVilkarModal(true);
    }

    function onRequestLukkVilkar(): void {
        setVisVilkarModal(false);
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--pinegreen" id="oppsummering">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h4 className="c-veileder__tittel c-veileder__tittel--resultat">{props.tittelMinimumTotaltLan}</h4>
                </div>
                <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                    <div className="c-veileder__underresultat-tekst">
                        <span>{kalkulerTotaltStudieLan()}</span>
                        <span className="c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                    </div>
                    <p className="c-veileder__tekst">{props.infoOmLan}</p>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h4 className="c-veileder__tittel c-veileder__tittel--resultat">{props.tittelMaksimumTotaltStipend}</h4>
                </div>
                <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                    <div className="c-veileder__underresultat-tekst">
                        <span>{kalkulerTotaltStudieStipend()}</span>
                        <span className="c-veileder__tekst--postfix">&nbsp;{props.valuta}</span>
                    </div>
                    <p className="c-veileder__tekst">{props.infoOmStipend}</p>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarClick}>
                        {props.lenketekstOmLanOgStipend}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarBModal}
                        onRequestClose={onRequestLukkVilkar}
                        ariaCloseText={props.vilkarLukkVilkårGjeldOgBetaling}
                    >
                        <ArticleContentComponent
                            headerinnhold={props.vilkarGjeldOgBetalingTittel}
                            contentinnhold={props.vilkarGjeldOgBetalingTekst}
                        />
                    </ModalCompontent>
                    
                </div>
                <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented"></div>
            </div>
        </div>
    )
}
